import React, { useContext } from 'react';
import {
	ICreateSubCategoryContext,
	CreateSubCategoryContext,
} from '../../../createSubCategoryState/createSubCategoryContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setFetchedTranslations,
		setTranslationTab,
		changeNameTranslation,
		IDSelectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<ICreateSubCategoryContext>(CreateSubCategoryContext);
	return (
		<MenuTranslationForm
			setFetchedTranslations={setFetchedTranslations}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={IDSelectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
